module.exports = __webpack_public_path__ + "static/media/work-progress-raport.6b5a0960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/work-progress-raport.jpg
// module id = 1928
// module chunks = 0